const ColorSelectorActionTypes = {
  HANDLE_SEQUENCE_CHANGE: 'HANDLE_SEQUENCE_CHANGE',
  HANDLE_BACK_CLICK: 'HANDLE_BACK_CLICK',
  HANDLE_OPTION_CHANGE: 'HANDLE_OPTION_CHANGE'
};

export default ColorSelectorActionTypes;
